import { Auth } from 'aws-amplify';

export const getUrlWithToken = async (url) => {
  const session = await Auth.currentSession();
  const token = session.getAccessToken().getJwtToken();
  const urlObj = new URL(url);
  urlObj.searchParams.append('token', token);
  window.open(urlObj.toString(), '_blank');
};
